module.exports = __webpack_public_path__ + "img/zhuanpan.fce92a16.png";